import type { Plan as PlanType, FeatureGroup } from './types';

export class Plan implements PlanType {
  identifier: string;

  featureGroup: FeatureGroup;

  sampleRate: number;

  ccDailyAllowance: number;

  // FIXME: Please fix this. You may refer to CFE-266 for more details.
  // eslint-disable-next-line func-params-args/func-params
  constructor(
    identifier: string,
    featureGroup: FeatureGroup,
    sampleRate: number,
    ccDailyAllowance: number,
  ) {
    this.identifier = identifier;
    this.featureGroup = featureGroup;
    this.sampleRate = sampleRate;
    this.ccDailyAllowance = ccDailyAllowance;
  }
}
